import { render, staticRenderFns } from "./EditMonthlyGoalAmount.vue?vue&type=template&id=58fee30b"
import script from "./EditMonthlyGoalAmount.vue?vue&type=script&lang=js"
export * from "./EditMonthlyGoalAmount.vue?vue&type=script&lang=js"
import style0 from "./EditMonthlyGoalAmount.vue?vue&type=style&index=0&id=58fee30b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports